import { ChangeDetectionStrategy, Component, computed, inject, input, output, signal } from '@angular/core';
import { ButtonComponent, ToastService } from '@webapp/ui';
import { SearchUsersComponent } from '@webapp/quoter/ui/components/search-users/search-users.component';
import { IUser } from '../../../interfaces/users.interface';
import { UsersStoreService } from '../../../store/users-store.service';

@Component({
	selector: 'app-agent-reassign-form',
	standalone: true,
	imports: [SearchUsersComponent, ButtonComponent],
	templateUrl: './agent-reassign-form.component.html',
	styleUrl: './agent-reassign-form.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgentReassignFormComponent {
	private readonly store = inject(UsersStoreService);
	private readonly toast = inject(ToastService);

	userId = input.required<string>();

	confirmed = output<void>();
	cancelled = output<void>();

	readonly selectedAgent = signal<IUser | null>(null);
	readonly submitting = signal(false);
	readonly canConfirm = computed(() => !!this.selectedAgent() && !this.submitting());

	getAgentName(agent: IUser): string {
		return agent.companyName?.trim() || `${agent.firstName ?? ''} ${agent.lastName ?? ''}`.trim();
	}

	setAgent(agent: IUser): void {
		this.selectedAgent.set(agent);
	}

	async confirm(): Promise<void> {
		const agent = this.selectedAgent();
		if (!agent || this.submitting()) return;

		this.submitting.set(true);
		const success = await this.store.reassignAgent(this.userId(), agent.agent?.id ?? '');
		this.submitting.set(false);

		if (!success) return;

		this.toast.showToast('PAS reasignado', 'El PAS del cliente se reasignó correctamente.', 'success');
		this.selectedAgent.set(null);
		this.confirmed.emit();
	}

	cancel(): void {
		this.selectedAgent.set(null);
		this.cancelled.emit();
	}
}
